import React from 'react';

import Grid from '@mui/material/Grid2';

import { BastionAbility } from "@dndModels";

import { makeStyles } from "@utilities/theme_utilities";

import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import AddButton from "@components/input/buttons/AddButton";

interface Props {
  abilities: BastionAbility[];
  // onChange: (abilities: BastionAbility[]) => void; 
  onExpand: (ability: BastionAbility) => void;
  onAdd: () => void;
  disabled?: boolean;
}

export default function BastionAbilityListInput({
  abilities,
  onExpand,
  onAdd,
  disabled = false,
}: Props) {
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        '&.tableHeader': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.secondary.dark,
        },
        '&.alternate': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.dark,
        },
      },
    });
  });
  
  const descWidth = Math.floor(window.innerWidth * 0.8);
  const { classes, cx } = useStyles();
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header padded">
          Bastion Abilities
        </span>
        { !disabled && 
          <AddButton onClick={onAdd} />
        }
      </Grid>
      { abilities.map((ability, key) => {
        return (
          <Grid
            key={ability.true_id}
            container
            spacing={0}
            direction="row"
            className={cx(classes.root, (key % 2 === 1 ? "alternate clickable" : "clickable" ))}
            onClick={() => {
              onExpand(ability);
            }}
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 2
              }}>
              { ability.name === "" ? `Nameless Bastion Facility` : ability.name }
            </Grid>
            <Grid
              size={{
                xs: 10
              }}>
              <DisplayStringWithReplacements
                display_string={ability.description}
                descWidth={descWidth}
              />
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}
